import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'atlas-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent {
  @Input() text: string;
  @Input() maxHeight: number | string;
  @Input() height: number | string;
  @Input() prescriptionText: string;
  @Input() limit: number;
  @Output() textChange = new EventEmitter<string>();
  public isFocused: boolean = false;

  focused(focused: boolean): void {
    this.isFocused = focused;
  }

  get maxHeightStyle(): string {
    return this.getStyleValue(this.maxHeight);
  }

  get heightStyle(): string {
    return this.getStyleValue(this.height);
  }

  private getStyleValue(v: number | string): string {
    if (v === null || typeof v === 'undefined') {
      return 'inherit';
    }
    if (typeof v === 'number') {
      return v + 'px';
    }
    return v;
}
}
